<template>
	<v-card
		v-if="!loading && !resolving"
		:id="hotKey.EventID"
		elevation="1"
		:ripple="false"
		class="d-flex flex-column h-100"
		:class="{active: isAudioPlaying, 'drop-target-container': dropzoneActive}"
		@contextmenu.prevent="openContextMenu"
		@click="toggleAudio()"
	>
		<div class="d-inline-flex justify-space-between w-100 px-1 px-xl-2 pt-xl-1">
			<v-tooltip v-if="expiredKillDateTime" location="bottom" max-width="200" text="This asset is expired">
				<template #activator="{props}">
					<v-icon v-bind="props" size="small" color="#FFD700" icon="mdi-alert" />
				</template>
			</v-tooltip>
			<div v-else-if="asset">
				<v-icon
					size="small"
					:color="assetTypeColor"
					:icon="icon"
					:class="{'text-disabled': assetIsLoading || assetIsMissing}"
				>
				</v-icon>
				<v-icon v-if="hotKey.ResolveTags" size="small" :color="assetTypeColor" icon="mdi-autorenew" />
			</div>
			<v-spacer v-else />

			<v-menu v-model="contextMenu" close-on-content-click>
				<template #activator="{props}">
					<v-icon v-bind="props" size="small">mdi-dots-vertical</v-icon>
				</template>
				<v-list>
					<!--                        Edit Audio-->
					<!--                        <v-list-item :disabled="!hotKey.AudioUrl">-->
					<!--                            <v-list-item-title class="text-body-2"-->
					<!--                                               :class="[assetIsLoading || assetIsMissing ? 'text&#45;&#45;disabled' : '']">-->
					<!--                                <v-menu v-model="editAudioMenu" :close-on-content-click="false" absolute-->
					<!--                                        :min-width="editAudioContainerWidth" content-class="elevation-24">-->
					<!--                                    <v-card>-->
					<!--                                        <v-card-actions>-->
					<!--                                            <v-icon small v-text="icon" :color="assetTypeColor"-->
					<!--                                                    class="ml-3 mr-3"></v-icon>-->
					<!--                                            <div class="text-body-1 ml-3 mr-6">{{ hotKey.Title }}</div>-->
					<!--                                            <div class="text-h5">{{ totalLength }}</div>-->
					<!--                                            <v-spacer></v-spacer>-->
					<!--                                            <v-btn icon v-if="!audioWaveformEditing">-->
					<!--                                                <v-icon>mdi-dots-vertical</v-icon>-->
					<!--                                            </v-btn>-->
					<!--                                            <v-btn icon @click.stop="toggleWaveformEditing"-->
					<!--                                                   :disabled="!waveformLoaded" v-if="!audioWaveformEditing">-->
					<!--                                                <v-icon>mdi-waveform</v-icon>-->
					<!--                                            </v-btn>-->
					<!--                                            <v-btn icon @click="editAudioMenu = false"-->
					<!--                                                   v-if="!audioWaveformEditing">-->
					<!--                                                <v-icon>mdi-close</v-icon>-->
					<!--                                            </v-btn>-->
					<!--                                            <v-btn text color="secondary" @click.stop="toggleWaveformEditing"-->
					<!--                                                   v-if="audioWaveformEditing">-->
					<!--                                                Cancel-->
					<!--                                            </v-btn>-->
					<!--                                            <v-btn outlined color="secondary" @click.stop="resetAudioWaveform"-->
					<!--                                                   v-if="audioWaveformEditing">-->
					<!--                                                Reset-->
					<!--                                            </v-btn>-->
					<!--                                            <v-btn depressed color="secondary" v-if="audioWaveformEditing">-->
					<!--                                                Save Changes-->
					<!--                                            </v-btn>-->
					<!--                                        </v-card-actions>-->
					<!--                                        <v-card-text class="pa-2">-->
					<!--                                            <v-container class="pa-0" style="background-color: #efefef;">-->
					<!--                                                <v-row no-gutters align="center">-->
					<!--                                                    <v-col cols="auto"-->
					<!--                                                           style="background-color: #dadada;border-radius: 3px;">-->
					<!--                                                        <v-btn text tile depressed x-small-->
					<!--                                                               @click.stop="playAudioWaveform"-->
					<!--                                                               height="45" width="24" style="min-width: 24px;"-->
					<!--                                                               :disabled="!waveformLoaded" v-if="!audioWaveformPlaying">-->
					<!--                                                            <v-icon>mdi-play</v-icon>-->
					<!--                                                        </v-btn>-->
					<!--                                                        <v-btn text tile depressed x-small-->
					<!--                                                               @click.stop="stopAudioWaveform"-->
					<!--                                                               height="45" width="24" style="min-width: 24px;"-->
					<!--                                                               v-if="audioWaveformPlaying">-->
					<!--                                                            <v-icon>mdi-pause</v-icon>-->
					<!--                                                        </v-btn>-->
					<!--                                                    </v-col>-->
					<!--                                                    <v-col>-->
					<!--                                                        <div-->
					<!--                                                            :id="`waveform-container-${hotKey.EventID}`"-->
					<!--                                                            style="position: relative;">-->
					<!--                                                            <Loader :value="!waveformLoaded" :size="45"/>-->
					<!--                                                        </div>-->
					<!--                                                    </v-col>-->
					<!--                                                </v-row>-->
					<!--                                            </v-container>-->
					<!--                                        </v-card-text>-->
					<!--                                    </v-card>-->
					<!--                                    <template v-slot:activator="{ props }">-->
					<!--                                                                <span-->
					<!--																	v-bind="props"-->
					<!--                                                                    @click="openEditAudioContainer">-->
					<!--                                                                    Edit Audio-->
					<!--                                                                </span>-->
					<!--                                    </template>-->
					<!--                                </v-menu>-->
					<!--                            </v-list-item-title>-->
					<!--                        </v-list-item>-->
					<v-list-item
						:disabled="auditionAudioMenu.open || hotKey.empty || assetIsMissing"
						@click="openAuditionAudioWidget($event, asset)"
					>
						<v-list-item-title class="text-body-2" :class="{'text-disabled': assetIsLoading}">
							Audition Audio
						</v-list-item-title>
					</v-list-item>
					<v-list-item link :disabled="page.locked || hotKey.empty || assetIsMissing">
						<v-list-item-title
							class="text-body-2"
							:class="{'text-disabled': assetIsLoading}"
							@click="openColorPicker"
						>
							<v-menu
								v-model="colorPickerMenu"
								absolute
								:close-on-content-click="false"
								content-class="elevation-24"
							>
								<HotKeyColorPicker :selected-color="hotKey.Color" @select-color="selectColor" />
								<template #activator="{props}">
									<span v-bind="props"> Set Color </span>
								</template>
							</v-menu>
						</v-list-item-title>
					</v-list-item>
					<v-list-item link :disabled="!hotKey.empty && !hotKey.ResolveTags">
						<v-list-item-title class="text-body-2" @click.stop="addHotKeyTags"> Add Tag </v-list-item-title>
					</v-list-item>
					<v-list-item link :disabled="page.locked || hotKey.empty || !hotKey.ResolveTags">
						<v-list-item-title class="text-body-2" @click.stop="resolveTag">
							Resolve Tag
						</v-list-item-title>
					</v-list-item>
					<v-list-item link :disabled="page.locked || hotKey.empty">
						<v-list-item-title
							class="text-body-2"
							:class="{'text-disabled': assetIsLoading}"
							@click.stop="openDeleteHotkeyDialog"
						>
							Remove Hotkey
						</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</div>
		<div
			v-if="!hotKey.empty"
			class="text-caption hotkey-title px-1 px-xl-2 w-100"
			:class="{
				'text-truncate': !assetIsLoading || assetIsMissing,
				'text-disabled': assetIsLoading || assetIsMissing
			}"
		>
			{{
				hotKey.loading
					? hotKey.EventID
						? "Saving hot key..."
						: (!assetIsMissing && asset?.Title) || "Missing Asset"
					: asset?.loading
						? "loading..."
						: (!assetIsMissing && asset?.Title) || "Missing Asset"
			}}
		</div>
		<div class="dropzone" :class="{dropzoneActive}" :style="{cursor: 'default'}" v-bind="dropzoneProps">
			<input v-bind="dropzoneInputProps" />
		</div>
		<div
			v-if="!hotKey.empty && !assetIsMissing"
			class="d-flex justify-space-between pa-0 w-100 px-1 px-xl-2 pb-xl-1"
		>
			<div class="text-caption audio-length">{{ secondsToFormat(progressLength, "mm:ss") }}</div>
			<div class="text-caption audio-length">{{ secondsToFormat(totalLength, "mm:ss") }}</div>
		</div>
		<DeleteDialog
			v-if="deleteDialog.open"
			:dialog="deleteDialog.open"
			:options="deleteDialog.options"
			@close="deleteDialog.open = false"
		/>
		<AuditionAudioWidget
			v-if="auditionAudioMenu.open && asset"
			ref="auditionAudioWidget"
			:menu="auditionAudioMenu"
			:event="hotKey"
			parent-component="hotkeys"
			@close-menu="closeAuditionAudioWidget"
		/>
		<v-dialog v-model="addTagsDialog.open" width="1000">
			<v-card color="white">
				<v-card-title class="text-h1 font-weight-bold pt-4 px-6">
					Add tags
					<v-spacer />
					<v-btn icon="mdi-close" variant="flat" density="compact" @click="closeAddHotkeyTags" />
				</v-card-title>
				<v-card-subtitle> You can add multiple comma separated tags </v-card-subtitle>
				<v-card-text>
					<div class="d-flex">
						<v-combobox
							v-model="addTagsDialog.tags"
							label="Tags"
							variant="outlined"
							density="compact"
							chips
							multiple
							clearable
							closable-chips
							hide-details
							:delimiters="[',']"
						/>
						<v-btn
							icon="mdi-plus-box"
							density="compact"
							variant="plain"
							color="green"
							size="x-large"
							:disabled="!addTagsDialog.tags?.length"
							@click="addRotation"
						/>
					</div>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-card>
	<v-container v-else-if="resolving" class="d-flex justify-center">
		<div class="text-caption hotkey-title">Resolving Asset...</div>
	</v-container>
	<div v-else class="d-flex justify-center align-center fill-height">
		<v-progress-circular indeterminate />
	</div>
</template>

<script>
/* Modules */
import AuditionAudioWidget from "@/components/AuditionAudioWidget.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import HotKeyColorPicker from "@/components/HotKeyColorPicker.vue";

/* Mixins */
import AssetPropertiesMixin from "@/mixins/AssetProperties";
import AuditionAudioMixin from "@/mixins/AuditionAudio";
import DurationFormatMixin from "@/mixins/DurationFormatMixin";
import SequencerPlayerStudioStatusMixin from "@/mixins/SequencerPlayerStudioStatus";

/* Enums */
import EventTypes from "@/enums/EventTypes";

/* Libraries */
import WaveSurfer from "wavesurfer.js";
import RegionsPlugin from "wavesurfer.js/dist/plugin/wavesurfer.regions.min";
import emitter from "@/emitter";
import moment from "moment";
import axios from "axios";
import {useDropzone} from "vue3-dropzone";
import {uuid} from "vue-uuid";

export default {
	name: "HotKeyItem",

	components: {
		DeleteDialog,
		HotKeyColorPicker,
		AuditionAudioWidget
	},

	mixins: [AssetPropertiesMixin, AuditionAudioMixin, DurationFormatMixin, SequencerPlayerStudioStatusMixin],

	props: [
		"selectedStation",
		"hotKey",
		"page",
		"hotkeyOutputDevice",
		"auditionOutputDevice",
		"bank",
		"maxGain",
		"fadeOutCheckboxEnabled"
	],

	emits: ["overrideHotkeyItem"],

	data() {
		return {
			contextMenu: false,
			deleteDialog: {
				open: false,
				options: {}
			},
			addTagsDialog: {
				open: false,
				tags: null
			},
			resolving: false,
			colorPickerMenu: false,
			editAudioMenu: false,
			audio: null,
			isAudioPlaying: false,
			audioLoaded: false,
			audioWaveformPlaying: false,
			audioWaveformEditing: false,
			waveform: null,
			waveformLoaded: false,
			startEndDurationFromPOIMarkup: {start: 0, end: 0, duration: 0},
			progressLength: null,
			totalLength: null,
			fadeOutTimeout: null,
			fadeCleanupTimeout: null,
			dropzoneProps: null,
			dropzoneInputProps: null,
			dropzoneRest: {},
			dropzoneActive: false,
			dropzoneUploadLoading: false
		};
	},

	computed: {
		asset() {
			return this.hotKey.Asset;
		},

		assetIsLoading() {
			return this.hotKey.loading || this.asset?.loading;
		},

		assetIsMissing() {
			return !this.asset?.loading && (!this.asset?.AssetID || this.asset?.isDeleted);
		},

		expiredKillDateTime() {
			return moment().isAfter(this.asset?.KillDateTime);
		},

		icon() {
			if (this.hotKey.loading || this.asset?.loading) {
				return "mdi-sync";
			} else if (this.assetIsMissing) {
				return "mdi-alert";
			} else {
				return `mdi-${this.$store.getters.getAssetTypeIcon(this.asset?.AssetTypeID)}`;
			}
		},

		editAudioContainerWidth() {
			return document.querySelector("#hotkeys-module").clientWidth;
		},

		clientId() {
			return this.$store.getters.clientId();
		},

		audioOutputType() {
			return this.$store.getters.getOutputType(this.bank) ?? "hotkey";
		},

		audioOutDevice() {
			return this.audioOutputType === "hotkey" ? this.hotkeyOutputDevice : this.auditionOutputDevice;
		},

		passAudioToWebRTC() {
			// todo: revisit this logic
			return (
				this.audioOutputType === "hotkey" &&
				this.$store.getters.isWebRTCStudio() &&
				this.studioSettings?.pass_hotkey_audio &&
				this.userIsHost &&
				this.isMicOn
			);
		},

		loading() {
			return this.$store.getters.getHotkeyLoading(
				this.hotKey.SequenceNumber ?? parseFloat(`${this.hotKey.row}.${this.hotKey.column}`)
			);
		},

		isMicOn() {
			return this.$store.getters.isMicOn();
		},

		playoutOutputDevice() {
			return this.$store.getters.getActiveStudioPlayoutOutputDevice();
		}
	},

	watch: {
		"hotKey.Color"() {
			this.setStyleColor();
		},

		assetTypeColor() {
			this.setStyleColor();
		},

		"hotKey.empty"(value, previousValue) {
			if (!value && previousValue) {
				this.dropzoneUploadLoading = false;
			}
		},

		asset(asset, prevAsset) {
			if (asset?.AssetID) {
				if (asset.AssetID !== prevAsset?.AssetID) {
					this.destroyAudioPlayer();
				}
				if (!this.audio) {
					this.$nextTick(() => {
						this.setUpAudioPlayer();
					});
				}
			} else {
				this.destroyAudioPlayer();
			}

			if (asset?.AssetID !== prevAsset?.AssetID) {
				this.resolving = false;
			}
		},

		assetIsMissing(isMissing, previousValue) {
			if (isMissing && !previousValue) {
				if (this.isAudioPlaying) {
					this.stopAudio();
				}
				this.destroyAudioPlayer();
			}
		},

		auditionOutputDevice() {
			if (this.audio) {
				this.setAudioOutDevice();
			}
		},

		passAudioToWebRTC(value, oldValue) {
			if (this.isAudioPlaying) {
				this.setAudioOutDevice();

				if (value && !oldValue) {
					this.connectAudioToWebRTC();
				} else if (!value && oldValue) {
					this.disconnectAudioFromWebRTC();
				}
			}
		},

		isMicOn(value, previousValue) {
			if (this.isAudioPlaying) {
				this.setAudioOutDevice();

				if (value && !previousValue) {
					this.connectAudioToWebRTC();
				} else if (!value && previousValue) {
					this.disconnectAudioFromWebRTC();
				}
			}
		},

		maxGain(value, previous) {
			if (value !== previous && this.audioContext && this.gainNode) {
				const now = this.audioContext.currentTime;
				// Immediately set the new gain value
				this.gainNode.gain.setValueAtTime(value, now);
			}
		},

		resolving(value, previous) {
			const completedResolving = !!previous && !value;
			if (completedResolving) {
				this.$nextTick(() => {
					this.setStyleColor();
				});
			}
		}
	},

	created() {
		// Close other open menus on right click
		window.addEventListener("contextmenu", this.closeContextMenu);
		emitter.on("fade-out-already-playing-hotkeys", this.handleFadeOutHotkey);
		emitter.on("page-changed", this.stopAudio);

		const {getRootProps, getInputProps, isDragActive, ...rest} = useDropzone({onDrop: this.onDrop});
		this.dropzoneProps = getRootProps();
		this.dropzoneInputProps = getInputProps();
		this.dropzoneActive = isDragActive;
		this.dropzoneRest = rest;
	},

	mounted() {
		if (!this.hotKey.empty) {
			this.setUpAudioPlayer();
			this.setStyleColor();
		}
	},

	beforeUnmount() {
		this.destroyAudioPlayer();

		window.removeEventListener("contextmenu", this.closeContextMenu);
		emitter.off("fade-out-already-playing-hotkeys", this.handleFadeOutHotkey);
		emitter.off("page-changed", this.stopAudio);
	},

	methods: {
		setStyleColor() {
			const color = this.hotKey?.Color ?? this.assetTypeColor;
			if (color) {
				this.$el.style.setProperty("--color", this.color2RGB(color));
			} else {
				this.$el.style.setProperty("--color", "transparent");
			}
		},

		color2RGB(color) {
			if (color.includes("rgb")) {
				return color.match(/\d+/g).slice(0, 3).join(","); //Keep the first 3 values in case we have rgba
			} else {
				return this.hex2rgb(color).match(/\d+/g).join(",");
			}
		},

		hex2rgb(color) {
			color = color.replace("#", "");
			const r = parseInt(color.length === 3 ? color.slice(0, 1).repeat(2) : color.slice(0, 2), 16);
			const g = parseInt(color.length === 3 ? color.slice(1, 2).repeat(2) : color.slice(2, 4), 16);
			const b = parseInt(color.length === 3 ? color.slice(2, 3).repeat(2) : color.slice(4, 6), 16);
			return `rgb(${r}, ${g}, ${b})`;
		},

		openContextMenu() {
			this.contextMenu = true;
		},

		closeContextMenu(ev) {
			if (!this.$el.contains(ev.target)) {
				this.contextMenu = false;
			}
		},

		setUpAudioPlayer(callback) {
			if (!this.asset.AudioUrl) {
				this.loadAssetAudio();
			} else {
				if (!this.audio) {
					const audioElement = new Audio(this.asset.AudioUrl);
					audioElement.crossOrigin = "anonymous";
					this.audio = audioElement;
				} else {
					if (this.audio.paused) {
						this.audio.load();
					}
				}

				// Set device
				this.setAudioOutDevice();

				this.audio.removeEventListener("loadeddata", this.onLoadedData);
				this.audio.addEventListener("loadeddata", this.onLoadedData);

				this.audio.removeEventListener("timeupdate", this.onTimeUpdate);
				this.audio.addEventListener("timeupdate", this.onTimeUpdate);

				this.audio.removeEventListener("play", this.onAudioPlay);
				this.audio.addEventListener("play", this.onAudioPlay);

				this.audio.removeEventListener("pause", this.onAudioPause);
				this.audio.addEventListener("pause", this.onAudioPause);

				this.audio.removeEventListener("ended", this.onAudioEnd);
				this.audio.addEventListener("ended", this.onAudioEnd);

				if (callback) {
					callback();
				}
			}
		},

		destroyAudioPlayer() {
			if (this.audio) {
				this.disconnectAudioFromWebRTC();
				this.audio.removeEventListener("loadeddata", this.onLoadedData);
				this.audio.removeEventListener("timeupdate", this.onTimeUpdate);
				this.audio.removeEventListener("play", this.onAudioPlay);
				this.audio.removeEventListener("pause", this.onAudioPause);
				this.audio.removeEventListener("ended", this.onAudioEnd);
				this.audio = null;
			}

			// Clean up Web Audio
			if (this.sourceNode) {
				this.sourceNode.disconnect();
				this.sourceNode = null;
			}
			if (this.gainNode) {
				this.gainNode.disconnect();
				this.gainNode = null;
			}
			if (this.audioContext) {
				// Close the context to free system resources
				this.audioContext.close();
				this.audioContext = null;
			}

			if (this.fadeOutTimeout) {
				this.$worker.clearTimeout(this.fadeOutTimeout);
				this.fadeOutTimeout = null;
			}

			if (this.fadeCleanupTimeout) {
				this.$worker.clearTimeout(this.fadeCleanupTimeout);
				this.fadeCleanupTimeout = null;
			}
		},

		onLoadedData() {
			this.audioLoaded = true;
			let totalDuration = 0;

			if (this.asset?.POIMarkup) {
				this.startEndDurationFromPOIMarkup = this.getStartEndDurationFromPOIMarkup(this.asset.POIMarkup);
				totalDuration = this.startEndDurationFromPOIMarkup.duration;
			} else {
				totalDuration = this.asset?.AssetID ? this.audio.duration : 0;
			}

			this.progressLength = totalDuration;
			this.totalLength = totalDuration;
			this.audio.currentTime = this.startEndDurationFromPOIMarkup.start;
		},

		onTimeUpdate() {
			if (this.isAudioPlaying) {
				this.progressLength = Math.abs(this.totalLength - this.getRelativePlaybackTime());

				const color = this.hotKey.Color ?? this.assetTypeColor;
				const progressPercentage = (this.getRelativePlaybackTime() / this.totalLength) * 100;

				const hotKeyEl = document.getElementById(this.hotKey.EventID);
				if (hotKeyEl) {
					hotKeyEl.style.setProperty("--color", this.color2RGB(color));
					hotKeyEl.style.setProperty("--progress", `${progressPercentage}%`);
				}
			}
		},

		getRelativePlaybackTime() {
			// we only playback audio between FadeIn.Position & FadeOut.Position + FadeOut.Duration
			// when audio playback happens this.audio.currentTime is set to the actual playback position
			// this function returns the this.audio.currentTime minus the FadeIn.Position
			// representing the amount of time that has played since the FadeIn
			// when no playback is happening this.audio.currentTime is 0, so in that case we return the FadeIn.Position
			return this.audio.currentTime < this.startEndDurationFromPOIMarkup.start
				? this.startEndDurationFromPOIMarkup.start
				: this.audio.currentTime - this.startEndDurationFromPOIMarkup.start;
		},

		onAudioPlay() {
			this.isAudioPlaying = true;
		},

		onAudioPause() {
			this.isAudioPlaying = false;
			this.disconnectAudioFromWebRTC();

			if (!this.hotKey.ResolveTags) {
				this.audio.load(); // load audio to prevent the blip if re-play the audio
			}

			const hotKeyEl = document.getElementById(this.hotKey.EventID);
			if (hotKeyEl) {
				hotKeyEl.style.setProperty("--color", "transparent");
				hotKeyEl.style.setProperty("--progress", 0);
			}
		},

		onAudioEnd() {
			this.isAudioPlaying = false;
			this.resolveTag();
		},

		loadAssetAudio() {
			this.$store.dispatch("getHotKeyAssetAudioUrl", this.hotKey);
		},

		toggleAudio() {
			if (this.hotKey?.loading || !this.hotKey?.AssetID || !this.asset?.AssetID) {
				return;
			}

			if (!this.audio) {
				this.setUpAudioPlayer(() => this.playAudio());
			} else if (this.audioLoaded) {
				this.isAudioPlaying ? this.stopAudio() : this.playAudio();
			}
		},

		async setAudioOutDevice() {
			const outputDevice = this.passAudioToWebRTC ? this.playoutOutputDevice : this.audioOutDevice;

			try {
				if (outputDevice) {
					// Try AudioContext first
					if (this.audioContext?.setSinkId) {
						await this.audioContext.setSinkId(outputDevice.device);
					}
					// Fallback to audio element
					else if (this.audio.sinkId !== outputDevice.device) {
						await this.audio.setSinkId(outputDevice.device);
					}
				} else {
					// No device provided, set default
					if (this.audioContext?.setSinkId) {
						await this.audioContext.setSinkId("default");
					} else if (this.audio.setSinkId) {
						await this.audio.setSinkId("default");
					}
				}
			} catch (error) {
				console.warn("Failed to set audio output device:", error);
			}
		},

		getNormalizationLevel() {
			if (this.hotKey?.Asset?.BypassAudioNormalization) {
				return 1.0;
			}

			const inRange = (max, min, value) => {
				return min <= value && value <= max;
			};
			const decibelToDigital = db => {
				return Math.pow(10.0, db / 20.0);
			};

			const normalizationTarget = this.selectedStation.NormalizationTarget;
			const assetLUFS = this.hotKey?.Asset?.AnalysisData.LUFS || null;

			// make sure we have valid LUFS, and it is less than 0 and greater than -50.0 db
			if (normalizationTarget != null && assetLUFS != null) {
				const stationDigitalTarget = decibelToDigital(normalizationTarget);
				const maxLUFS = 0.0;
				const minLUFS = -50.0;
				if (inRange(maxLUFS, minLUFS, assetLUFS)) {
					const assetDigitalLevel = decibelToDigital(assetLUFS);
					return stationDigitalTarget / assetDigitalLevel;
				}
			}
			return 1.0; // if we don't have valid LUFS or NormalizationTarget, just return 1.0 (no change)
		},

		initAudioContext() {
			if (!this.audioContext) {
				this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
			}

			if (!this.gainNode) {
				this.gainNode = this.audioContext.createGain();
				// Connect gain to destination once
				this.gainNode.connect(this.audioContext.destination);
			}

			// Only create MediaElementSource once
			if (!this.sourceNode) {
				this.sourceNode = this.audioContext.createMediaElementSource(this.audio);
				// Connect source to gain once
				this.sourceNode.connect(this.gainNode);
			}
		},

		async playAudio() {
			// Initialize AudioContext and gain/source nodes
			this.initAudioContext();
			await this.audioContext.resume(); // safe inside user gesture

			// Set the audio output device
			await this.setAudioOutDevice();

			// Connect to WebRTC if needed
			if (this.passAudioToWebRTC) {
				this.connectAudioToWebRTC();
			}

			// Get the current time at the exact moment we schedule the fade
			const now = this.audioContext.currentTime;
			// Stop all pending automations
			this.gainNode.gain.cancelScheduledValues(now);
			// Always start at zero gain before playback
			this.gainNode.gain.setValueAtTime(0.0001, now); // Small non-zero start avoids audio clicks/pops caused by ramping from 0

			// Schedule fade-in before starting playback
			const targetVolume = this.getNormalizationLevel();
			if (this.fadeInLength) {
				this.gainNode.gain.linearRampToValueAtTime(targetVolume, now + this.fadeInLength);
			} else {
				this.gainNode.gain.setValueAtTime(targetVolume, now);
			}

			// Start playback after scheduling the fade
			try {
				await this.audio.play();

				// Schedule fade-out if needed
				if (this.fadeOutLength) {
					this.scheduleFadeOutAudio();
				}

				if (this.fadeOutCheckboxEnabled) {
					emitter.emit("fade-out-already-playing-hotkeys", {audio: this.audio, bank: this.bank});
				}
			} catch (DOMException) {
				if (DOMException.name === "NotSupportedError") {
					this.$store.commit("SHOW_NOTIFICATION_WITH_TYPE", {
						message: "Audio format not supported or source not found."
					});
				}
			}
		},

		scheduleFadeOutAudio() {
			const totalDuration = this.startEndDurationFromPOIMarkup.duration;
			const delaySeconds = Math.max(0, totalDuration - this.fadeOutLength);

			if (this.fadeOutTimeout) {
				this.$worker.clearTimeout(this.fadeOutTimeout);
				this.fadeOutTimeout = null;
			}
			this.fadeOutTimeout = this.$worker.setTimeout(() => this.fadeOutAudio(), delaySeconds * 1000);
		},

		fadeOutAudio() {
			const now = this.audioContext.currentTime;
			const stopTime = now + this.fadeOutLength;

			// Stop all pending automations
			this.gainNode.gain.cancelScheduledValues(now);

			// Use cancelAndHoldAtTime (if supported) or a ramp anchor
			// This prevents the "volume jump" if a fade-in was active
			if (this.gainNode.gain.cancelAndHoldAtTime) {
				this.gainNode.gain.cancelAndHoldAtTime(now);
			} else {
				// Fallback: This forces the current automation value to "freeze" where it is
				const currentVolume = this.gainNode.gain.value;
				this.gainNode.gain.setValueAtTime(currentVolume, now);
			}
			// Start the fade to zero
			this.gainNode.gain.linearRampToValueAtTime(0, stopTime);

			// Clear the old cleanup timeout if the user triggers a new fade-out rapidly
			if (this.fadeCleanupTimeout) {
				clearTimeout(this.fadeCleanupTimeout);
				this.fadeCleanupTimeout = null;
			}

			// Start the cleanup timeout
			this.fadeCleanupTimeout = setTimeout(() => {
				this.stopAudio();
				this.onAudioEnd();
			}, this.fadeOutLength * 1000);
		},

		forceFadeOutAudio() {
			// Immediately kill the 'scheduled' fade-out if one is pending
			if (this.fadeOutTimeout) {
				this.$worker.clearTimeout(this.fadeOutTimeout);
				this.fadeOutTimeout = null;
			}

			// Kill any existing cleanup timers to prevent multiple stopAudio calls
			if (this.fadeCleanupTimeout) {
				clearTimeout(this.fadeCleanupTimeout);
				this.fadeCleanupTimeout = null;
			}

			const fadeOutLength = this.selectedStation.FadeLength ?? 0;
			const now = this.audioContext.currentTime;
			const stopTime = now + fadeOutLength;

			// Cancel any ongoing gain ramps
			this.gainNode.gain.cancelScheduledValues(now);

			const currentVolume = this.gainNode.gain.value;
			this.gainNode.gain.setValueAtTime(currentVolume, now);

			if (fadeOutLength > 0) {
				this.gainNode.gain.linearRampToValueAtTime(0, stopTime);
				this.fadeCleanupTimeout = setTimeout(() => this.stopAudio(), fadeOutLength * 1000);
			} else {
				// If fade length is 0, just stop immediately
				this.gainNode.gain.setValueAtTime(0, now);
				this.stopAudio();
			}
		},

		stopAudio() {
			if (this.audio) {
				this.audio.pause();
				if (this.fadeOutTimeout) {
					this.$worker.clearTimeout(this.fadeOutTimeout);
					this.fadeOutTimeout = null;
				}
			}
		},

		connectAudioToWebRTC() {
			this.capturedStream = this.audio.captureStream();
			const gain = this.getNormalizationLevel();
			this.$store.dispatch("addSignalerOutputSource", {
				id: this.hotKey.EventID,
				stream: this.capturedStream,
				gain: gain
			});
		},

		disconnectAudioFromWebRTC() {
			if (this.capturedStream) {
				this.$store.dispatch("removeSignalerOutputSource", {
					id: this.hotKey.EventID,
					stream: this.capturedStream
				});
				this.capturedStream = null;
			}
		},

		addHotKeyTags() {
			if (this.hotKey.ResolveTags) {
				this.addTagsDialog.tags = this.hotKey.ResolveTags;
			}
			this.addTagsDialog.open = true;
			this.contextMenu = false;
		},

		closeAddHotkeyTags() {
			this.addTagsDialog.open = false;
		},

		addRotation() {
			const sequenceNumber = parseFloat(`${this.hotKey.row}.${this.hotKey.column}`);
			this.$store.commit("setHotkeyLoading", {sequenceNumber, loading: true});
			this.closeAddHotkeyTags();

			const promise = this.hotKey.empty
				? this.$store.dispatch("addHotKey", {
						OrganizationID: this.$store.getters.getOrgID(),
						PlaylistID: this.page.PlaylistID,
						EventType: EventTypes.PlayAsset,
						SequenceNumber: sequenceNumber,
						ResolveTags: this.addTagsDialog.tags
					})
				: this.$store.dispatch("updateHotKey", {
						hotKeyEvent: this.hotKey,
						updatedData: {ResolveTags: this.addTagsDialog.tags}
					});

			promise.then(() => {
				this.$store.commit("setHotkeyLoading", {sequenceNumber, loading: false});
				this.resolveTag();
			});
		},

		resolveTag() {
			this.contextMenu = false;
			if (this.hotKey.ResolveTags) {
				this.resolving = true;
				this.$store.dispatch("getDefaultAssetTypes").then(response => {
					let assetTypes = "";
					if (response.status === 200 && response.data.LocalizerAssetTypeIDs) {
						assetTypes = response.data.LocalizerAssetTypeIDs.map(assetType => `"${assetType}"`);
					}
					this.$store
						.dispatch("resolveTag", {
							stationID: this.selectedStation.StationID,
							eventID: this.hotKey.EventID,
							playlistID: this.hotKey.PlaylistID,
							assetTypes: assetTypes
						})
						.then(response => {
							if (response.data.data?.resolveVoiceTagEvent?.resolveAssets.length > 0) {
								this.$store.commit("SHOW_SUCCESS_NOTIFICATION", {
									message: response.data.data.resolveVoiceTagEvent.resolveReason
								});
							} else {
								this.$store.commit("SHOW_NOTIFICATION_WITH_TYPE", {message: "Could not resolve tags!"});
							}
							this.resolving = false;
						});
				});
			}
		},

		openDeleteHotkeyDialog() {
			this.deleteDialog = {
				open: true,
				options: {
					description: "Hot key",
					object: this.asset,
					objectId: this.hotKey,
					action: "deleteHotKey",
					successCallback: () => {
						// In case of audio playing, stop it
						this.contextMenu = false;
						if (this.isAudioPlaying) {
							this.stopAudio();
						}
					},
					onComplete: res => {
						if (res.status === 404) {
							// Unsubscribe from Asset and StationAsset topics if there are subscriptions
							if (this.$store.getters.isSubscribedToAssetTopics(this.asset.AssetID)) {
								this.$store.dispatch("assetSubscription", {
									assetID: this.asset.AssetID,
									subscribe: false
								});
								this.$store.dispatch("stationAssetSubscription", {
									assetID: this.asset.AssetID,
									subscribe: false
								});
								this.$store.commit("removeAssetHotkeySubscription", {
									assetID: this.asset.AssetID,
									eventID: this.event.EventID
								});
							}

							this.$store.commit("removeHotkeyByEventId", this.event.EventID);
						}
					}
				}
			};
		},

		openColorPicker() {
			this.colorPickerMenu = true;
		},

		selectColor(color) {
			this.$store
				.dispatch("updateHotKey", {hotKeyEvent: this.hotKey, updatedData: {Color: color}})
				.then(response => {
					if (response.status == 200) {
						this.$store.commit("SHOW_SUCCESS_NOTIFICATION", {
							message: "Hot key color successfully updated!"
						});
						this.colorPickerMenu = false;
						this.contextMenu = false;
					} else {
						this.$store.commit("SHOW_NOTIFICATION_WITH_TYPE", {
							message: "An error occurred when trying to update the hot key color."
						});
					}
				});
		},

		openEditAudioContainer() {
			this.editAudioMenu = true;

			this.$nextTick(() => {
				this.initWaveform();
			});
		},

		initWaveform() {
			if (!this.waveform) {
				this.waveform = WaveSurfer.create({
					container: `#waveform-container-${this.hotKey.EventID}`,
					partialRender: true,
					height: 45,
					waveColor: "rgba(0, 44, 198, 0.34)",
					cursorColor: "transparent",
					cursorWidth: 2,
					barHeight: 0.7,
					hideScrollbar: true,
					// regionsMinLength: 60,
					plugins: [RegionsPlugin.create({})]
				});
				this.waveform.load(this.audio);

				this.waveform.on("ready", () => {
					this.waveformLoaded = true;
				});

				this.waveform.on("finish", () => {
					this.audioWaveformPlaying = false;
				});
			}
		},

		toggleWaveformEditing() {
			if (!this.audioWaveformEditing) {
				this.audioWaveformEditing = true;
				if (!this.waveform.region) {
					this.waveform.region = {
						id: "region",
						start: 0,
						end: this.waveform.getDuration()
					};
				}
				this.waveform.addRegion(this.waveform.region);

				this.waveform.regions.list["region"].on("update-end", () => {
					this.waveform.region.start = this.waveform.regions.list["region"].start;
					this.waveform.region.end = this.waveform.regions.list["region"].end;
				});
			} else {
				this.audioWaveformEditing = false;
				this.waveform.clearRegions();
			}
		},

		playAudioWaveform() {
			this.waveform.on("ready", () => {
				this.waveform.play();
			});

			this.audioWaveformPlaying = true;
			this.waveform.setCursorColor("#002193");
			if (this.audioWaveformEditing) {
				this.waveform.regions.list["region"].play();
			} else {
				this.waveform.play();
			}
		},

		stopAudioWaveform() {
			this.audioWaveformPlaying = false;
			this.waveform.pause();
		},

		resetAudioWaveform() {
			this.waveform.regions.list["region"].onResize(this.waveform.getDuration());
			if (this.waveform.region.start) {
				this.waveform.regions.list["region"].onResize(-this.waveform.region.start, "start");
			}
			this.waveform.region.start = 0;
			this.waveform.region.end = this.waveform.getDuration();
		},

		onDrop(acceptFiles) {
			if (acceptFiles) {
				this.dropzoneUploadLoading = true;
				this.$store.dispatch("getAssetTypes").then(assetTypes => {
					let assetTypeID = assetTypes.find(a => a.QuickRecord)?.AssetTypeID;
					if (assetTypeID) {
						const sequenceNumber = parseFloat(`${this.hotKey.row}.${this.hotKey.column}`);

						if (this.hotKey.SequenceNumber === sequenceNumber) {
							this.$emit("overrideHotkeyItem");
							emitter.on("overrideHotkey", () => {
								this.$store.commit("setHotkeyLoading", {sequenceNumber, loading: true});
								this.$store.dispatch("deleteHotKey", this.hotKey);
								this.importAsset(sequenceNumber, assetTypeID, acceptFiles[0]);
							});
						} else {
							this.$store.commit("setHotkeyLoading", {sequenceNumber, loading: true});
							this.importAsset(sequenceNumber, assetTypeID, acceptFiles[0]);
						}
					}
				});
			}
		},

		importAsset(sequenceNumber, assetTypeID, file) {
			this.$store.dispatch("useImportServiceGraphql").then(response => {
				if (response.status === 200) {
					if (response.data.data.useImportService) {
						const assetID = uuid.v1();
						const request = {
							description: `Hot key import asset: ${file.name}`,
							jobType: "AssetImportV2",
							organizationId: this.$store.getters.getOrgID(),
							jobRequestData: {
								asset: {
									AssetID: assetID,
									AssetTypeID: assetTypeID,
									OriginalFileName: file.name,
									Title: file.name
								},
								event: {
									Asset: {
										AssetID: assetID,
										AssetTypeID: assetTypeID,
										OriginalFileName: file.name,
										Title: file.name
									},
									AssetID: assetID,
									AssetTypeID: assetTypeID,
									StationID: this.selectedStation.StationID,
									PlaylistID: this.page.PlaylistID,
									SequenceNumber: sequenceNumber
								}
							}
						};
						this.$store.dispatch("createAssetImport", request).then(response => {
							const {url} = response.data.data.createAssetImport;
							let audioFormData = new FormData();
							audioFormData.append("file", file);
							axios
								.put(url, audioFormData, {
									headers: {
										"access-control-allow-origin": "*"
									}
								})
								.then(res => {
									if (res.status !== 200) {
										this.$store.commit("SHOW_NOTIFICATION_WITH_TYPE", {
											message: "Failed to upload audio file."
										});
									}
								})
								.catch(err => {
									console.error(err);
								});
						});
					} else {
						return this.$store
							.dispatch("importAssetEvent", {
								playlistID: this.page.PlaylistID,
								sequenceNumber,
								assetTypeID,
								title: file.name
							})
							.then(response => {
								let audioFormData = new FormData();

								audioFormData.append("key", response.data.fields.key);
								audioFormData.append("bucket", response.data.fields.bucket);
								audioFormData.append("Policy", response.data.fields.Policy);
								audioFormData.append("X-Amz-Algorithm", response.data.fields["X-Amz-Algorithm"]);
								audioFormData.append("X-Amz-Credential", response.data.fields["X-Amz-Credential"]);
								audioFormData.append(
									"X-Amz-Security-Token",
									response.data.fields["X-Amz-Security-Token"]
								);
								audioFormData.append("X-Amz-Signature", response.data.fields["X-Amz-Signature"]);
								audioFormData.append("X-Amz-Date", response.data.fields["X-Amz-Date"]);
								audioFormData.append("file", file);

								axios.post(response.data.url, audioFormData, {
									headers: {
										"access-control-allow-origin": "*"
									}
								});
							});
					}
				} else {
					this.$store.commit("SHOW_NOTIFICATION_WITH_TYPE", {
						message: "Failed to get import service."
					});
				}
			});
		},

		handleFadeOutHotkey({audio, bank}) {
			if (this.bank === bank && this.audio !== audio && this.isAudioPlaying) {
				this.forceFadeOutAudio();
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.v-card {
	background-color: rgba(var(--color), 0.07);
	border: 2px solid transparent;
	cursor: pointer;

	&.active {
		border: 2px solid rgb(var(--color)) !important;
		background: linear-gradient(90deg, rgba(var(--color), 0.3) var(--progress), rgba(var(--color), 0.07) 0%);
	}

	&.v-card--link:focus:before {
		opacity: 0;
	}

	.container {
		> * {
			width: 100%;
		}
	}

	.hotkey-title {
		display: -webkit-box;
		overflow: hidden;
		position: absolute;
		text-align: center;
		text-overflow: ellipsis;
		top: 50%;
		transform: translateY(-50%);
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
	}

	.audio-length {
		color: $grey-300;
	}

	@media only screen and (max-width: 1920px) {
		.v-icon {
			font-size: 16px !important;
		}

		.hotkey-title {
			font-size: 0.65rem !important;
			line-height: 0.875rem !important;
			-webkit-line-clamp: 2;
		}

		.audio-length {
			font-size: 0.65rem !important;
			line-height: 0.875rem !important;
		}
	}

	&.v-theme--dark {
		background-color: rgba(var(--color), 0.15);
		border: 2px solid rgb(var(--color));
		color: rgb(var(--color));

		.mdi-dots-vertical {
			color: rgb(var(--color));
		}

		.audio-length {
			color: $ihm-grey1;
		}

		.hotkey-title {
			color: $ihm-white;
			font-weight: 700;
		}

		&.active {
			background: linear-gradient(90deg, rgba(var(--color), 0.46) var(--progress), rgba(var(--color), 0.15) 0);

			.mdi-dots-vertical {
				color: $ihm-white;
			}

			.audio-length {
				color: $ihm-white;
			}
		}
	}
}

.dropzone {
	width: 100%;
	height: 100%;
	display: flex !important;
	justify-content: center;
	align-items: center;
	cursor: default;
}
</style>
